export * from "./types.js";
export * from "./copy.js";
export {
  calculateSecondEarnerDays,
  ftbARemaining,
  assertNoVerdict,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { SecondEarnerRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of second-earner rulesets by financial year. Historical years stay
 * registered so re-runs resolve against the rules in force then. */
export const SECOND_EARNER_RULESETS: Record<string, SecondEarnerRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the second-earner ruleset for a financial year, or throw if unknown. */
export function secondEarnerRulesFor(fy: FinancialYear): SecondEarnerRuleSet {
  const rules = SECOND_EARNER_RULESETS[fy];
  if (!rules) {
    throw new Error(`no second-earner ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent second-earner ruleset — the default for live "this year" calcs. */
export const SECOND_EARNER_CURRENT_FY: FinancialYear = "2025-26";
